import Model from './Model'
import dayjs from 'dayjs'
import Avatar from './Avatar'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Incident extends Model {
  resource() {
    return 'incidents'
  }

  get avatarText() {
    return this.first_name.charAt(0) + this.last_name.charAt(0)
  }

  avatar() {
    return this.hasMany(Avatar)
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }
}
